import React from 'react';
// import dp from '../images/dp.jpg'
import dp from '../images/about.jpg'
import skills from "../objects/skills.json"

const About = () => {
    return (
        <div id="about">
            <div className="container-fluid about-bg pt-5">
                <h1 className="text-center about-title mx-auto wow fadeInRight" data-wow-delay="0.3s" data-wow-duration="1s" id="about">About</h1><br />
                <center>
                    <div className="wow fadeInLeft nbsp" id="line" data-wow-delay="0.3s" data-wow-duration="1s"> </div>
                </center>

                <div className="row">

                    <div className="col-sm-12 ">
                            <span className="circle-image mx-auto d-block mt-5 wow slideInUp" data-wow-delay="0.3s" data-wow-duration="1s">
                                <img src={dp} alt='dp'></img>
                            </span>
                    </div>

                    <div className="col-sm-12">
                        <h4 className="text-white text-center mt-3 font-weight-bold wow lightSpeedIn" data-wow-delay="0.3s" data-wow-duration="1s" id="who">Who's this guy?</h4>
                        <p className="lead text-center text-white font-weight-light wow lightSpeedIn" data-wow-delay="0.3s" data-wow-duration="1s" id="bootcamper">4+ Years of experience in the IT industry. <br /> I bring expertise in web development, application modernization,
                        and application support. <br /> I am eager to leverage my programming skills to contribute to both organizational
                        growth and my personal development. </p>
                    </div>

                    <div className="inner">
                        <div className="header-skill">
                            <h1 className="font-weight-bold text-white pt-5 wow bounceInLeft" data-wow-delay="0.3s" data-wow-duration="1s" id="skills">My Skills</h1>
                        </div>
                        <div className="container-skill wow bounceInLeft" data-wow-delay="0.3s" data-wow-duration="1s">
                            
                            {skills.map((skill, key) => {
                                return (
                                    <div className="skill-box" key={key}>
                                    <div className="skill-title">
                                        <div className="img">
                                            <img className="skill-icon" alt='skills' src={`${skill.imgSrc}`}></img>
                                        </div>
                                        <h3 className="skilltitle">{skill.name}</h3>
                                    </div>
                                    <div className="skilldesc">{skill.description}</div>

                                    {skill.checked.map((check, k) => {
                                        return (
                                            <span key={k} className="fa fa-star checked"></span>
                                        )
                                    })}

                                    {skill.notChecked.map((notCheck, k) =>{
                                        return (
                                            <span key={k} className="fa fa-star"></span>
                                        )
                                    })}
                                </div>
                                )
                            })}

                        </div>
                    </div>
                </div>
            </div>
        </div >

    )
}

export default About;